import { MyAreaNote } from '@msc-b2c/interfaces/types';
import { OrderNotes } from './OrderNotes';
import { getActiveSession, useGetBookingQuery } from '@msc-b2c/shared-utils';
import { skipToken } from '@reduxjs/toolkit/query';

export function OrderNotesWrapper(orderNotesProps: Readonly<MyAreaNote>) {
  const { bookingNumber = '' } = getActiveSession();

  const bookingQuery = useGetBookingQuery(bookingNumber || skipToken);
  const booking = bookingNumber !== '' ? bookingQuery?.data : undefined;

  return booking && <OrderNotes {...orderNotesProps} />;
}

export default OrderNotesWrapper;

OrderNotesWrapper.aemResourceType = 'b2c-website-foundation/components/mymsc/ordernotes';
